var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('router-link',{attrs:{"to":_vm.link}},[_c('el-tooltip',{attrs:{"content":_vm.name,"placement":"right","effect":"light"}},[_c('el-button',{attrs:{"type":"primary","size":"medium","icon":"el-icon-edit-outline","circle":""}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }